import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fill-down",
  "use": "icon-fill-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fill-down\">\n<g id=\"icon-fill-down_Direction/fill-down\">\n<g id=\"icon-fill-down_Frame 2\">\n<path id=\"icon-fill-down_Polygon 2\" d=\"M8.38411 10.5391C8.18421 10.7789 7.81579 10.7789 7.61589 10.5391L3.68341 5.82009C3.41202 5.49443 3.6436 5 4.06752 5H8L11.9325 5C12.3564 5 12.588 5.49443 12.3166 5.82009L8.38411 10.5391Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fill-down.svg
// module id = jVzw
// module chunks = 140